module.exports = __webpack_public_path__ + "img/DE00023.2f812168.png";